import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './LoanDetails.css'
import PageTitle from '../components/UI/PageTitle'
import { getLoanById } from '../api/Index'
import { useAuth } from '../api/Authcontext'

const LoanDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { userData: user } = useAuth();
    const [loan, setLoan] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLoanDetails = async () => {
            setLoading(true);
            setError(null);
            try {
                // Get loan ID from URL query parameters
                const searchParams = new URLSearchParams(location.search);
                const loanId = searchParams.get('id');
                
                if (!loanId) {
                    setError('Loan ID not provided');
                    return;
                }

                const response = await getLoanById(loanId);
                setLoan(response.data);
            } catch (err) {
                setError(err.message);
                console.error('Error fetching loan details:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchLoanDetails();
    }, [location.search]);

    const GuarantorCard = ({ user, legacyCreditsUsed, requestedAt, respondedAt, status }) => {
        const formatDate = (dateString) => {
            if (!dateString) return 'Not available';
            return new Date(dateString).toLocaleDateString();
        };

        return (
            <div className='guarantor-card'>
                <div>
                    <h4>{user?.name || 'Unknown Guarantor'}</h4>
                    <div className='loan-details-details'>
                        <p><strong>Credits Used:</strong> {legacyCreditsUsed || 0}</p>
                        <p><strong>Requested:</strong> {formatDate(requestedAt)}</p>
                        <p><strong>Responded:</strong> {formatDate(respondedAt)}</p>
                    </div>
                </div>
                <div className='guarantor-status-container'>
                    <p className='guarantor-status'>{status || 'Pending'}</p>
                </div>
            </div>
        )
    }

    if (loading) {
        return (
            <div>
                <PageTitle title="Loan Details" />
                <div>Loading loan details...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <PageTitle title="Loan Details" />
                <div style={{color: 'red'}}>Error: {error}</div>
            </div>
        );
    }

    if (!loan) {
        return (
            <div>
                <PageTitle title="Loan Details" />
                <div>Loan not found.</div>
            </div>
        );
    }

    const formatDate = (dateString) => {
        if (!dateString) return 'Not available';
        return new Date(dateString).toLocaleDateString();
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-KE', {
            style: 'currency',
            currency: 'KES'
        }).format(amount || 0);
    };

    const handleEditLoan = () => {
        navigate(`/admin/edit-loan/${loan._id}`);
    };

  return (
    <div>
      <PageTitle title="Loan Details" />

      

      {/* Admin Edit Button */}
      {user && user.role === 'admin' && (
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button 
            onClick={handleEditLoan}
            style={{
              backgroundColor: '#007800',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            Edit Loan
          </button>
        </div>
      )}

      <div>
        <h3>APPLICANT INFORMATION</h3>
        <div className='loan-details-details'>
            <p><strong>Name:</strong> {loan.user?.name || 'Not available'}</p>
            <p><strong>Email:</strong> {loan.user?.email || 'Not available'}</p>
        </div>
      </div>

      <div>
        <h3>LOAN DETAILS</h3>
        <div className='loan-details-details'>
            <p><strong>Amount:</strong> {formatCurrency(loan.amount)}</p>
            <p><strong>Total Amount (with interest):</strong> {formatCurrency(loan.totalAmount)}</p>
            <p><strong>Total Repayments:</strong> {formatCurrency(loan.totalRepayments || 0)}</p>
            <p><strong>Remaining Amount:</strong> {formatCurrency(loan.remainingAmount || 0)}</p>
            <p><strong>Monthly Payment:</strong> {formatCurrency(loan.monthlyRepayment)}</p>
            <p><strong>Repayment Period:</strong> {loan.repaymentPeriod ? `${loan.repaymentPeriod} months` : 'Not specified'}</p>
            <p><strong>Application Date:</strong> {formatDate(loan.applicationDate)}</p>
            <p><strong>Status:</strong> {loan.status}</p>
            <p><strong>Interest Rate:</strong> {loan.interestRate || 5}%</p>
            <p><strong>Purpose:</strong> {loan.purpose || 'Not specified'}</p>
            {loan.notes && <p><strong>Notes:</strong> {loan.notes}</p>}
        </div>
      </div>

      <div>
        <h3>GUARANTORS</h3>
      </div>
      <div>
        {loan.guarantors && loan.guarantors.length > 0 ? (
          loan.guarantors.map((guarantor, index) => (
            <GuarantorCard key={index} {...guarantor} />
          ))
        ) : (
          <div>No guarantors assigned to this loan.</div>
        )}
      </div>

      {/* Repayments Section */}
      <div>
        <h3>REPAYMENTS HISTORY</h3>
        {loan.repayments && loan.repayments.length > 0 ? (
          <div className="repayments-table-container">
            <table className="repayments-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Receipt Number</th>
                </tr>
              </thead>
              <tbody>
                {loan.repayments.map((repayment, index) => (
                  <tr key={index}>
                    <td>{formatDate(repayment.date)}</td>
                    <td>{formatCurrency(repayment.amount)}</td>
                    <td>{repayment.receiptNumber || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div>No repayments recorded yet.</div>
        )}
      </div>

    </div>
  )
}

export default LoanDetails